import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from 'design-system';
import {environment} from '../../../environments/environment';
import {Location} from '@angular/common';
import {EformsService} from '../../services/eforms.service';
import {ActivatedRoute} from '@angular/router';
import {Zdarzenie} from '../../models/zdarzenie.model';
import { DataFilterZdarzeniaService } from 'src/app/services/data-filter-zdarzenia.service';
import {NewsletterService} from '../../services/newsletter.service';
import { filter, takeUntil } from 'rxjs/operators';
import { DestroyComponent } from 'src/app/components/destroy/destroy.component';
import { ZdarzeniaFiltrModel } from 'src/app/models/zdarzenia-filtr.model';
import { DateHelper } from 'src/app/helpers/dateHelper';


@Component({
  selector: 'app-zdarzenia',
  templateUrl: './zdarzenia.component.html',
  styleUrls: ['./zdarzenia.component.scss']
})
export class ZdarzeniaComponent extends DestroyComponent implements OnInit {
  readonly env = environment;
  krs: string;
  idSubskrypcji: string;
  zdarzeniaAktualneLista: Zdarzenie[];
  zdarzeniaAktualne: Zdarzenie[];
  zdarzeniaWczesniejszeLista: Zdarzenie[];
  zdarzeniaWczesniejsze: Zdarzenie[];
  pokazZdarzeniaWczesniejsze: boolean;

  constructor(private breadcrumbService: BreadcrumbService,
              private eformsService: EformsService,
              private location: Location,
              private activatedRoute: ActivatedRoute,
              private dataFilterService: DataFilterZdarzeniaService,
              private newsletterService: NewsletterService
  ) {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params.id) {
          this.getInitData(params.id);
        } else {
          this.goBack();
        }
      });
    this.subscribeToFilter();
  }

  subscribeToFilter(): void {
    this.dataFilterService.dataFilter
      .pipe(
        takeUntil(this.destroy$),
        filter(filter => filter != null)
      )
      .subscribe(filtr => {
        this.dataFilterService.loading$.next(true);

        this.zdarzeniaAktualneLista = null;
        if (this.pokazZdarzeniaWczesniejsze) {
          this.dataFilterService.loadingWczesniejszeZdarzenia$.next(true);
          this.zdarzeniaWczesniejszeLista = null;
        }
        setTimeout(() => {
          this.filterZdarzenia(filtr);
        }, 250);
      });
  }

  private filterZdarzenia(filtr: ZdarzeniaFiltrModel) {
    this.zdarzeniaAktualneLista = this.filtrujZdarzenia(filtr, this.zdarzeniaAktualne);
    this.dataFilterService.loading$.next(false);

    if (this.pokazZdarzeniaWczesniejsze) {
      this.zdarzeniaWczesniejszeLista = this.filtrujZdarzenia(filtr, this.zdarzeniaWczesniejsze);
      this.dataFilterService.loadingWczesniejszeZdarzenia$.next(false);
    }
  }

  private filtrujZdarzenia(filtr: ZdarzeniaFiltrModel, zdarzenia: Zdarzenie[]): Zdarzenie[]  {
    let data = zdarzenia || [];

    if(filtr.sygnatura) {
      data = data.filter(x => x.sygnatura === filtr.sygnatura);
    }

    if(filtr.numerWpisu) {
      data = data.filter(x => x.numerWpisu === filtr.numerWpisu);
    }

    if(filtr.zdarzenie?.length) {
      data = data.filter(x => filtr.zdarzenie.some(z => z === x.zdarzenie));
    }

    if(filtr.dataOd) {
      const dataOd = DateHelper.getDate(filtr.dataOd);
      data = data.filter(x => x.dataZdarzenia && DateHelper.getDate(x.dataZdarzenia) >= dataOd);
    }

    if(filtr.dataDo) {
      const dataDo = DateHelper.getDate(filtr.dataDo);
      data = data.filter(x => x.dataZdarzenia && DateHelper.getDate(x.dataZdarzenia) <= dataDo);
    }

    return data;
  }

  getInitData(id: string): void {
    this.idSubskrypcji = id;
    this.eformsService.pobierzSzczegolySubskrypcji(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe( response => {
        this.krs = response.naglowek.systemId;
        this.zdarzeniaAktualneLista = response.zdarzenia;
        this.zdarzeniaAktualne = response.zdarzenia;
        this.updateBreadcrumbs();
        this.dataFilterService.loading$.next(false);
      });
      this.newsletterService.zdarzenaWczesniejsze$
        .pipe(
          takeUntil(this.destroy$),
          filter(() => this.pokazZdarzeniaWczesniejsze)
        )
        .subscribe(response => {
          this.zdarzeniaWczesniejsze = response;
          this.zdarzeniaWczesniejszeLista = this.filtrujZdarzenia(this.dataFilterService.dataFilter.getValue(), this.zdarzeniaWczesniejsze);
          this.dataFilterService.loadingWczesniejszeZdarzenia$.next(false);
        });
  }

  pokazWczesniejsze(pokazWczesniejsze: boolean): void {
    if(this.dataFilterService.loadingWczesniejszeZdarzenia$.getValue() === false) {
      this.pokazZdarzeniaWczesniejsze = pokazWczesniejsze;
      if (pokazWczesniejsze) {
        this.dataFilterService.loadingWczesniejszeZdarzenia$.next(true);
        this.zdarzeniaWczesniejszeLista = null;
        this.newsletterService.initZdarzenaWczesniejsze(this.idSubskrypcji);
      }
    }
  }

  updateBreadcrumbs(): void {
    this.breadcrumbService.updateBreadcrumbList([
      {
        label: 'Portal Rejestrów Sądowych',
        path: this.env.portalUrl
      },
      {
        label: 'Krajowy Rejestr Sądowy',
        path: this.env.portalUrl + '/krs'
      },
      {
        label: 'Newsletter KRS',
        path: '/'
      },
      {
        label: `KRS ${this.krs}`,
        path: '/zdarzenia'
      },
    ]);
  }

  goBack(): void {
    this.location.back();
  }

}
